import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as uuid from 'uuid';
import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
	selector: 'app-radio-input',
	templateUrl: './radio-input.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => RadioInputComponent),
			multi: true,
		},
	],
})
export class RadioInputComponent implements OnInit, OnDestroy, ControlValueAccessor {
	@Input() label?: string;
	@Input() name?: string;
	@Input() emitEvents?: boolean = true;
	@Input() orientation?: string = 'horizontal';
	@Input() options?: {
		value: string|boolean|number;
		label?: string;
		icon?: string;
		colour?: string;
		badge?: string;
		empty?: boolean;
		disabled?: boolean;
	}[]

	private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

	public disabled: boolean = false;
	public uuid = uuid.v4();
	public control: UntypedFormControl = new UntypedFormControl('');
	private onChange = (_: any) => {};
	private onTouched = () => {};

	public ngOnInit(): void {
		this.control.valueChanges
			.pipe(takeUntil(this.componentDestroyed$))
			.subscribe((value) => {
				this.onChange(value);
				this.onTouched();
			});
	}

	public ngOnDestroy(): void {
		this.componentDestroyed$.next(true);
		this.componentDestroyed$.complete();
	}

	public writeValue(value: any): void {
		this.control.setValue(value, { emitEvent: false });
	}

	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	public setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
		if (isDisabled) {
			this.control.disable({ emitEvent: false });
		} else {
			this.control.enable({ emitEvent: false });
		}
	}
}
